import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { getStoredValue } from "./storagehelper";

const AuthenticateRouter = ({ children }) => {
  const isLoggedIn = getStoredValue("userID");
  
  return isLoggedIn  ? (
    children
  ) :  
    <Navigate to="/public/Login" replace />
 
};

export default AuthenticateRouter;
